module.exports = __webpack_public_path__ + "static/favicon/browserconfig.xml";